export const TASK_PRIORITY_LABELS = {
  A: "High",
  B: "Medium",
  C: "Low",
};

export function taskPriorityLabel(value) {
  if (value == null || value === "") return "";
  return TASK_PRIORITY_LABELS[value] || String(value);
}
